<template>
  <div class="Model">
    <Modal
      v-model="modelStatus"
      :title="title"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90">
        <FormItem label="AppName" prop="appName">
            <Input v-model="formValidate.appName" placeholder="请输入appName"></Input>
        </FormItem>
        <FormItem label="名称" prop="title">
            <Input v-model="formValidate.title" placeholder="请输入名称"></Input>
        </FormItem>
        <FormItem label="排序" prop="order">
            <Input v-model="formValidate.order" placeholder="请输入排序" @on-keyup="formValidate.order=formValidate.order.replace(/[^\d]/g,'')"></Input>
        </FormItem>
        <FormItem label="注册方式" prop="addressType">
          <RadioGroup v-model="formValidate.addressType">
            <Radio label="0">自动注册</Radio>
            <Radio label="1">手动录入</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="机器地址" prop="addressList">
            <Input v-model="formValidate.addressList" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入执行器地址列表，多地址逗号分隔"></Input>
        </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button  class="ys-cancel" @click="cancel('formValidate')" style="width: 100px; margin-right: 20px">取消</Button>
      <Button class="ys-confirm" type="primary" @click="ok('formValidate')" style="width: 100px;">确认</Button>
    </div>
    </Modal>
  </div>
</template>
<script>
import { 
  mapActions
} from "vuex";
export default {
  props:{
    modelStatus: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '新增执行器'
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formValidate: {
        appName: '',
        title: '',
        order: '',
        addressType: '',
        addressList: ''
      },
      ruleValidate: {
        appName: [
          { required: true, message: '请输入appName', trigger: 'blur' },
          { type: 'string', min: 4, message: 'AppName长度限制为4~64', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        order: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        addressType: [
          { required: true, message: '请选择注册方式', trigger: 'change' }
        ],
        addressList: [
          { required: true, message: '请输入机器地址', trigger: 'blur' }
        ],
      }
    }
  },
  methods:{
    ...mapActions([
      'sa_SpringJobGroupView_save', // 新建保存
      'sa_SpringJobGroupView_update', // 编辑保存
      'sa_SpringJobGroupView_loadById', // 编辑回显
    ]),
    ok (name) {
      console.log(this.formValidate)
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.id ? this.sa_SpringJobGroupView_updates() : this.sa_SpringJobGroupView_saves();
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    cancel (name) {
      this.$refs[name].resetFields();
      this.$emit('handle-model', {code: 2})
    },
    // 新建保存
    async sa_SpringJobGroupView_saves() {
      try {
        const data = await this.sa_SpringJobGroupView_save(this.formValidate);
        console.log(data, '---')
        this.$Message.success('新建成功!');
        this.$emit('handle-model', {code: 1})
        this.$refs['formValidate'].resetFields();
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑保存
    async sa_SpringJobGroupView_updates() {
      try {
        let ev = {
          ...this.formValidate,
          id: this.id
        }
        const data = await this.sa_SpringJobGroupView_save(ev);
        console.log(data, '---')
        this.$Message.success('编辑成功!');
        this.$emit('handle-model', {code: 1})
        this.$refs['formValidate'].resetFields();
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑回显
    async sa_SpringJobGroupView_loadByIds() {
      try {
        const data = await this.sa_SpringJobGroupView_loadById({jobGroup: this.id});
        this.formValidate = data;
        this.formValidate.addressType = data.addressType + '';
        this.formValidate.order = data.order + '';
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    console.log('编辑', this.id)
    // 编辑回显
    this.id ? this.sa_SpringJobGroupView_loadByIds() : '';
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-top: 40px;
}
</style>